import styled from 'styled-components'

export const CheckAllContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  padding-left: ${props => props.theme.spacing.sp8};
`

export const AcceptRejectButtons = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;

  button {
    padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp32};
  }
`
